import { colors } from "../../../styles/figmaColors";
import { useTranslation } from "react-i18next";
import { Tag } from "../Tag/Tag";
import "../../../../i18n/i18n";

type EnergyType =
  | "fuel"
  | "diesel"
  | "electric"
  | "GPL"
  | "GNV"
  | "hybrideFuel"
  | "hybrideDiesel";

const energyProps: Record<
  EnergyType,
  { backgroundColor: string; textColor: string }
> = {
  electric: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
  },
  hybrideFuel: {
    backgroundColor: colors["colors/system/warning/warning_ultraLight"],
    textColor: colors["colors/system/warning/warning_normal"],
  },
  hybrideDiesel: {
    backgroundColor: colors["colors/system/warning/warning_ultraLight"],
    textColor: colors["colors/system/warning/warning_normal"],
  },
  fuel: {
    backgroundColor: colors["colors/surfaces/background/background_level1"],
    textColor: colors["colors/text/darkGrey"],
  },
  diesel: {
    backgroundColor: colors["colors/surfaces/background/background_level1"],
    textColor: colors["colors/text/darkGrey"],
  },
  GPL: {
    backgroundColor: colors["colors/surfaces/background/background_level1"],
    textColor: colors["colors/text/darkGrey"],
  },
  GNV: {
    backgroundColor: colors["colors/surfaces/background/background_level1"],
    textColor: colors["colors/text/darkGrey"],
  },
};

interface TableTagVehicleEnergyTypeProps {
  type: string;
}

export const TableTagVehicleEnergyType = (
  props: TableTagVehicleEnergyTypeProps,
) => {
  const { t } = useTranslation();
  const energyProp = energyProps[props.type as EnergyType];
  if (!energyProp) {
    return null;
  }

  return (
    <Tag
      text={t(`vehicles.energy.${props.type}`)}
      backgroundColor={energyProp.backgroundColor}
      textColor={energyProp.textColor}
    />
  );
};
